import type { Dict } from "../core.js";
import type { customers as vi } from "../vi/customers.js";

/** Namespace `customers` — PLAT-2026-114, English. */
export const customers: Dict<typeof vi> = {
  workspacesTitle: "{app} workspaces",
  workspacesSubtitle:
    "Read live from {app} on every visit — the hub keeps no copy. The plan shown is the plan IN EFFECT (expiry applied), not the raw stored value.",
  usersTitle: "{app} users",
  usersSubtitle: "Read live from {app} on every visit — the hub keeps no copy.",
  searchWorkspaces: "Search by name, slug, tax code or owner email",
  searchUsers: "Search by email or name",
  search: "Search",
  loadMore: "Load more",
  loadFailed: "Could not read data from the app.",
  empty: "No results.",
  notSupported: "This app does not support customer administration yet.",
  notConfigured: "The hub is not configured to call {app} (missing URL or read secret).",

  colName: "Name",
  colOwner: "Owner",
  colPlan: "Plan",
  colBranches: "Branches",
  colMembers: "Members",
  colCreated: "Created",
  colLastActive: "Last active",
  colEmail: "Email",
  colWorkspaces: "Workspaces",
  colRole: "Role",
  colJoined: "Joined",
  colStatus: "Status",
  never: "never",
  verified: "verified",
  unverified: "unverified",

  status_active: "active",
  status_trialing: "trial",
  status_grace: "grace",
  status_expired: "expired",
  status_cancelled: "cancelled",
  status_continuity: "continuity",
  status_none: "no subscription",
  status_past_due: "past due",
  status_canceled: "canceled",
  until: "until {at}",
  managedByHub: "granted by hub",

  back: "← Workspace list",
  detailTitle: "Workspace “{name}”",
  sectionPlan: "Plan",
  sectionMembers: "Members",
  sectionHistory: "Plan history",
  storedVsEffective: "Stored: {plan} · {status}",
  noHistory: "No plan changes yet.",
  eventBy: "by {by}",
  eventReason: "Reason: {reason}",

  changePlan: "Change plan…",
  planChangeNotConfigured: "Plan changes unavailable: the hub lacks the plan secret for this app (`HQ_<APP>_PLAN_SECRET`).",
  planChangeNoPermission: "Changing plans requires the Owner role.",
  dialogTitle: "Manual plan change",
  action: "Action",
  action_trial: "Grant a trial",
  action_grant: "Grant a plan (no charge)",
  action_revoke: "Revoke to the free plan",
  actionHint_trial: "Up to 90 days. Falls back to the free plan at expiry, no grace period.",
  actionHint_grant: "Up to 12 months. For partners / special customers. Falls back to the free plan at expiry.",
  actionHint_revoke: "Revokes trial / manually granted plans. The app refuses plans backed by a payment.",
  plan: "Plan",
  endsAt: "End date",
  reason: "Reason (at least 10 characters)",
  preview: "Before → after: {before} → {after}",
  confirm: "Confirm plan change",
  confirmAgain: "Click again to confirm",
  cancel: "Cancel",
  saving: "Saving…",
  saved: "Plan changed. The customer may need to reload to see the new plan label.",
  replayed: "This request was already recorded — the result is unchanged.",
  saveFailed: "Could not change the plan.",
};
